import { PATHS } from 'config/paths';

const defaultPath = PATHS.dashboard;

export const LEGACY_URLS = {
    accountsettings: defaultPath,
    'gdpr.delete': PATHS.privacyDelete,
    'gdpr.download': PATHS.privacyDownload,
    upgradesubscription: PATHS.upgrade,
    freetrial: PATHS.fromApp.freeTrial,
    purchasesubscription: PATHS.fromApp.purchaseSubscription,
    uploadavatar: defaultPath,
    externalservice: PATHS.fromApp.externalService,
    editpaymentmethod: `${defaultPath}?update-payment-method=true`,
    donotsell: `${defaultPath}#doNotSell`,
    familygroup: `${defaultPath}?anchor-family-group=true`,
    bf2021: PATHS.blackFridayCheckout, // this is in use in the app dev menu but in the real app the bf purchase trigger will be used instead
    bf: PATHS.blackFridayCheckout,
};
